import React from "react";
import styled from "@emotion/styled";
import colors from '../../../sass/brand_palette.scss';
import withTranslator from "../Translator/withTranslation";


const em = px => `${px / (16 * 1.6)}rem`;

const HeadlineInner = styled.div`
    position: relative;
    color: white;
    font-size: ${em(56)};
    line-height: 1.5;
    max-width: 100%;
    padding: 0 1%;
    text-shadow: 1px 1px 1px ${colors.blue1};
    font-weight:700;
    @media (max-width: 576px) {
      padding-bottom:0.5em;
    }
    @media (max-width: 767px) {
        max-width: 100%;
        font-size: ${em(30)};
        text-align:center;
        padding-bottom:1em;
        padding-left: 16px;
        padding-right: 16px;
    }
    
    @media (min-width: 768px) {
      font-size: ${em(48)};
      padding:0px;
      padding-bottom:0.5em;
    }
    @media (min-width: 992px) {
      font-size: ${em(52)};
      padding:0px;
    }
    @media (min-width: 1200px) {
      font-size: ${em(56)};
      padding:0px;
    }
    @media (min-width: 1600px) {
      font-size: ${em(70)};
      padding:0px;
    }
`;

const HeadlineComponent = (props) => {
  return (
    <div>
        <HeadlineInner className="headline">{props.t('headline.slogan')}</HeadlineInner>
    </div>
  );
};

export const Headline = withTranslator(HeadlineComponent);